import {
  DetailsSection,
  TableCellCondition,
  TableCellStatus,
} from '@src/application/modules/shared/components/Campaigns/DetailsTable/DetailsTable';
import { getTargetingLabel } from '../../helpers';
import { useTranslation } from 'react-i18next';
import React from 'react';

type AudienceDetailsProps = {
  audienceType: string;
  audiences: { [key in number]: any };
  mapAudienceNameToPosition?: Map<number, string>;
};

export const AudienceDetails = ({ audienceType, audiences, mapAudienceNameToPosition }: AudienceDetailsProps) => {
  const { t } = useTranslation();

  const audienceTypeLabel = audienceType === 'trigger' ? t('Trigger') : t('Segment');

  return (
    <>
      {Object.entries(audiences).map(([position, conditions], idx) => {
        return conditions && conditions.length ? (
          <React.Fragment key={`${audienceType}-details-${idx}`}>
            <DetailsSection
              title={`${audienceTypeLabel} ${Number(position) + 1}`}
              array={[{ audienceName: mapAudienceNameToPosition?.get(Number(position)) }]}
            >
              {({ audienceName }) => (
                <TableCellCondition colSpan={3}>
                  <strong>{audienceName}</strong>
                </TableCellCondition>
              )}
            </DetailsSection>
            <DetailsSection title="" array={conditions}>
              {({ name, condition, value, success }) => (
                <>
                  <TableCellCondition>{getTargetingLabel(name, t)}</TableCellCondition>
                  <TableCellCondition>{condition}</TableCellCondition>
                  <TableCellCondition>{value}</TableCellCondition>
                  <TableCellStatus success={success} />
                </>
              )}
            </DetailsSection>
          </React.Fragment>
        ) : null;
      })}
    </>
  );
};
